import feedMap from '../../../components/feedMap/index.vue';
import { isWeiXin } from '@/pages/micro-detail/utils';
export default {
  components: {
    feedMap
  },
  data() {
    return {
      isWeiXin: isWeiXin(),
      mapOptions: {
        maxZoom: 18,
        minZoom: 3,
        enableDblclickZoom: true,
        fixCenterWhenPinch: true,
        fixCenterWhenResize: true,
        enableIconClick: true,
        displayOptions: true,
        enableCapture: true,
        style: 'grayed-out'
      }
    };
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    isMapFeedFinished: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    poiInfo() {
      var _this$detail$poi_info;
      return ((_this$detail$poi_info = this.detail.poi_info) === null || _this$detail$poi_info === void 0 || (_this$detail$poi_info = _this$detail$poi_info.template) === null || _this$detail$poi_info === void 0 ? void 0 : _this$detail$poi_info[0]) || {};
    }
  },
  methods: {
    overlayAdd(e) {
      const {
        maxX,
        maxY,
        minX,
        minY,
        pointObj = {}
      } = e;
      const bound = `(${minX},${minY},${maxX},${maxY})`;
      const fromMapData = {
        isFromMap: true,
        bound,
        pointObj
      };
      this.$emit('getFeedData', fromMapData);
    }
  }
};